export const changeField = (
  setter: (value: string) => void,
  messageSetter: (message: string) => void,
  value: string
) => {
  setter(value);
  messageSetter('');
};
